import React from "react";
import { ErrorBoundaryContextProvider } from '@/presentation/providers/error-boundary-provider';
import { SettingsHandlersProvider } from "@/presentation/providers/settings-handlers-provider";
import { KiverascapeLayout } from "@/presentation/layouts/kiverascape-layout";
import { breadcrumbsSettingsActionMetadataOverridesEdit } from "@/presentation/components/commons/breadcrumbs";
import { Flashbar, } from "@cloudscape-design/components-themed/components";
import { useNotifications } from "@/presentation/providers/notifications-provider";
import SettingsActionMetadataOverridesFormWrapper from "@/presentation/pages/settings/action-metadata-overrides/settings-action-metadata-overrides-form-wrapper";
const MakeSettingsActionMetadataOverridesPage = () => {
    const { notifications } = useNotifications();
    return (React.createElement(ErrorBoundaryContextProvider, null,
        React.createElement(KiverascapeLayout, { breadcrumbMenu: breadcrumbsSettingsActionMetadataOverridesEdit(), content: React.createElement(SettingsHandlersProvider, null,
                React.createElement(SettingsActionMetadataOverridesFormWrapper, null)), contentType: "default", notifications: React.createElement(Flashbar, { items: notifications, 
                // @ts-ignore
                stackItems: true }) })));
};
export default MakeSettingsActionMetadataOverridesPage;
